import { AxiosRequestConfig } from "axios";
import { IDeltaOptionChainReport, IDeltaOptionChainSearch, IDeltaOptions, IDeltaPortfolioReport, IDeltaSearch, IDeltaSimulationPosition, IDeltaSimulationRequest, IDeltaSummaryReport } from "src/Interfaces/automaticMarketMakingDelta";
import { Report } from "src/Interfaces/TableInterfaces";
import { DropdownItem } from "src/Interfaces/dropdownInterfaces";
import { deleteRequest, getRequest, getTable, postRequest } from "./requestTemplates";

export const getDeltaOptions = (config?: AxiosRequestConfig): Promise<IDeltaOptions> =>
  getRequest("/v1/automaticMarketMaking/GetDeltaOptions", config);

export const getDeltaSummaryTable = (search: IDeltaSearch, offset: number | null, pageSize: number | null,
  sortingType?: string, additional?: DropdownItem, config?: AxiosRequestConfig): Promise<Report<IDeltaSummaryReport>> =>
  getTable("/v1/automaticMarketMaking/GetDeltaSummaryTable", search, offset, pageSize, sortingType, additional, config);

export const getDeltaPortfolioTable = (search: IDeltaSearch, offset: number | null, pageSize: number | null,
  sortingType?: string, additional?: DropdownItem, config?: AxiosRequestConfig): Promise<Report<IDeltaPortfolioReport>> =>
  getTable(
    "/v1/automaticMarketMaking/GetDeltaPortfolioTable", search, offset, pageSize, sortingType, additional, config);

export const getDeltaOptionChainTable = (search: IDeltaOptionChainSearch, offset: number | null, pageSize: number | null,
  sortingType?: string, additional?: DropdownItem, config?: AxiosRequestConfig): Promise<Report<IDeltaOptionChainReport>> =>
  getTable(
    "/v1/automaticMarketMaking/GetDeltaOptionChainTable", search, offset, pageSize, sortingType, additional, config);

export const saveDeltaSimulation = (request: IDeltaSimulationRequest, config?: AxiosRequestConfig): Promise<IDeltaSimulationPosition[]> =>
  postRequest("/v1/automaticMarketMaking/SaveDeltaSimulation", request, config);

export const deleteDeltaSimulation = (request: IDeltaSearch & { id: number }, config?: AxiosRequestConfig): Promise<IDeltaSimulationPosition[]> =>
  deleteRequest("/v1/automaticMarketMaking/DeleteDeltaSimulation", request, config);

export const resetDeltaSimulation = (search: IDeltaSearch, config?: AxiosRequestConfig): Promise<IDeltaSimulationPosition[]> =>
  deleteRequest("/v1/automaticMarketMaking/ResetDeltaSimulation", search, config);
